module.exports = __webpack_public_path__ + "img/unassigned.5097b024.png";